export default "__VITE_ASSET__sITaWVB___"